/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Bar_Custom_KgInputs */

const en_us2_workout_logging_bar_custom_kg = /** @type {(inputs: Workout_Logging_Bar_Custom_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bar weight`)
};

const pt_br2_workout_logging_bar_custom_kg = /** @type {(inputs: Workout_Logging_Bar_Custom_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso da barra`)
};

const es_419_workout_logging_bar_custom_kg = /** @type {(inputs: Workout_Logging_Bar_Custom_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso de la barra`)
};

const pt_pt2_workout_logging_bar_custom_kg = /** @type {(inputs: Workout_Logging_Bar_Custom_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso da barra`)
};

const fr_fr2_workout_logging_bar_custom_kg = /** @type {(inputs: Workout_Logging_Bar_Custom_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poids de la barre`)
};

const de_de2_workout_logging_bar_custom_kg = /** @type {(inputs: Workout_Logging_Bar_Custom_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantelgewicht`)
};

const it_it2_workout_logging_bar_custom_kg = /** @type {(inputs: Workout_Logging_Bar_Custom_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso del bilanciere`)
};

/**
* | output |
* | --- |
* | "Bar weight" |
*
* @param {Workout_Logging_Bar_Custom_KgInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_bar_custom_kg = /** @type {((inputs?: Workout_Logging_Bar_Custom_KgInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Bar_Custom_KgInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_bar_custom_kg(inputs)
	if (locale === "es-419") return es_419_workout_logging_bar_custom_kg(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_bar_custom_kg(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_bar_custom_kg(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_bar_custom_kg(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_bar_custom_kg(inputs)
	return en_us2_workout_logging_bar_custom_kg(inputs)
});
export { workout_logging_bar_custom_kg as "workout-logging.bar_custom_kg" }